import React, { useRef, useEffect } from 'react';
import CopyWithBar from '../../../Common/CopyBlocks/CopyWithBar';
import HighlightedCopy from '../../../Common/CopyBlocks/HighlightedCopy';
import videomov from '../../../../assets/contemporary/helmet/contemporary_helmet_mobile.mov';
import video from '../../../../assets/contemporary/helmet/contemporary_helmet_mobile.webm';
import poster from '../../../../assets/contemporary/helmet/contemporary_helmet_mobile_poster.png';
import videomovD from '../../../../assets/contemporary/helmet/contemporary_helmet_desktop.mov';
import videoD from '../../../../assets/contemporary/helmet/contemporary_helmet_desktop.webm';
import posterD from '../../../../assets/contemporary/helmet/contemporary_helmet_desktop_poster.png';
import './Helmet.scss';

function ContemporaryHelmet({ screenWidth }) {
  // const contemporaryHelmetCanvas = useRef();
  const contemporaryHelmetSection = useRef();
  const contemporaryHelmetAnimation = useRef();
  // const images = useRef([]);
  // const ratio = useRef();
  const highlight1 = useRef();
  const highlight2 = useRef();
  const videoMRef = useRef();
  const videoDRef = useRef();
  const copyData = [
    {
      copy: 'Since the 1980s, most suits have been built around a solid piece called a Hard Upper Torso unit. ',
      ref: highlight1
    },
    {
      copy: 'Helmets are attached directly to this upper torso, making it impossible to turn the spacesuit\'s "head" without turning the full body.',
      ref: highlight2
    }
  ];

  const copyData1 =
    'Shorter astronauts often have trouble positioning their heads properly in the helmet. Some have used padding to gain more height, and to protect their chins from being rubbed raw on the neck ring.';

  useEffect(() => {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          if (entry['isIntersecting'] === true) {
            if (entry['intersectionRatio'] > 0.6) {
              screenWidth > 480 ? videoDRef.current.play() : videoMRef.current.play();
            }
          }
        });
      },
      { threshold: [0, 0.6] }
    );
    observer.observe(contemporaryHelmetAnimation.current);
  }, [screenWidth]);

  // useEffect(() => {
  //   ratio.current = screenWidth > 480 ? 1.2 : 1.777;
  //   images.current = [];
  //   // set canvas properties
  //   const canvas = contemporaryHelmetCanvas.current.getContext('2d');
  //   // Set the size of the canvas
  //   contemporaryHelmetCanvas.current.width =
  //     screenWidth > 480 ? Math.min(window.innerWidth * 0.3, 492) : window.innerWidth;
  //   contemporaryHelmetCanvas.current.height =
  //     contemporaryHelmetCanvas.current.width * ratio.current;

  //   // Count the frames and set the path to the images
  //   const frameCount = 41;
  //   const currentFrame = (index, screenSize) =>
  //     `https://morgan-stanley-creating-space-cdn.s3.amazonaws.com/contemporary/helmet/${screenSize}/EMU_HELMET${(
  //       index + 1
  //     )
  //       .toString()
  //       .padStart(2, '0')}.png`;
  //   // Set start frame

  //   const target = {
  //     frame: 0
  //   };

  //   // Go through frames from start to finish
  //   const anim = gsap.timeline({
  //     scrollTrigger: {
  //       trigger: contemporaryHelmetAnimation.current,
  //       start: 'top 50%',
  //       // endTrigger: contemporaryHelmetSection.current,
  //       // end: 'bottom bottom',
  //       scrub: 1
  //     }
  //   });

  //   if (screenWidth < 481) {
  //     for (let i = 0; i < frameCount; i++) {
  //       const img = new Image();
  //       img.src = currentFrame(i, 'mobile');
  //       images.current.push(img);
  //     }
  //   } else {
  //     for (let i = 0; i < frameCount; i++) {
  //       const img = new Image();
  //       img.src = currentFrame(i, 'desktop');
  //       images.current.push(img);
  //     }
  //   }

  //   anim.add('start').to(
  //     target,
  //     {
  //       frame: frameCount - 1,
  //       snap: 'frame',
  //       duration: 5,
  //       ease: 'linear',
  //       onUpdate: () => {
  //         render();
  //       }
  //     },
  //     'start'
  //   );

  //   images.current[0].onload = render;

  //   function render() {
  //     canvas.clearRect(
  //       0,
  //       0,
  //       contemporaryHelmetCanvas.current.width,
  //       contemporaryHelmetCanvas.current.height
  //     );
  //     canvas.drawImage(
  //       images.current[target.frame],
  //       0,
  //       0,
  //       contemporaryHelmetCanvas.current.width,
  //       contemporaryHelmetCanvas.current.height
  //     );
  //   }
  // }, [screenWidth, images]);

  return (
    <section className="helmet helmet-contemporary" ref={contemporaryHelmetSection}>
      <div className="helmet__upper helmet__upper-contemporary">
        <HighlightedCopy copyData={copyData} />
      </div>
      <div className="helmet__lower helmet__lower-contemporary">
        <div
          className="helmet__animation helmet__animation-contemporary"
          ref={contemporaryHelmetAnimation}
        >
          {screenWidth > 480 ? (
            <video
              muted
              playsInline
              preload="auto"
              ref={videoDRef}
              className="video"
              poster={posterD}
            >
              <source src={videomovD} type="video/quicktime" />
              <source src={videoD} type="video/webm" />
            </video>
          ) : (
            <video
              muted
              playsInline
              preload="auto"
              ref={videoMRef}
              className="video"
              poster={poster}
            >
              <source src={videomov} type="video/quicktime" />
              <source src={video} type="video/webm" />
            </video>
          )}
          {/* <canvas className="helmet__animation__canvas" ref={contemporaryHelmetCanvas} /> */}
        </div>
        <div className="helmet__lower__text helmet__lower__text-contemporary">
          <CopyWithBar copyData={copyData1} />
        </div>
      </div>
    </section>
  );
}

export default ContemporaryHelmet;
